import { ENV } from '@/pages/home/_config/config';

/**
 * AI Gallery 灰度白名单（按 userInfo.openid 匹配）
 *
 * - 仅 pro 环境生效；dev / test / pre 默认全开，便于联调
 * - 列表包含 '*' 时全员放开（全面上线时改为 ['*']）
 * - 列表为空时全员屏蔽（当前 pro 状态：屏蔽所有人）
 * - 同时控制：头部导航入口（NavHeader）+ /aigallery/* 路由访问（Auth wrapper）
 */
export const AIGALLERY_WHITELIST: string[] = ['*'];

export const isAIGalleryAllowed = (openid?: string): boolean => {
  if (ENV !== 'pro') return true;
  if (AIGALLERY_WHITELIST.includes('*')) return true;
  return !!openid && AIGALLERY_WHITELIST.includes(openid);
};
